<template>
  <div class="float-quick-wrap" :style="{ left: pos.left + 'px', top: pos.top + 'px' }" @mousedown="handleMouseDown"
    v-if="user">
    <div class="float-sidebar">
      <ul class="menu-list">
        <li class="menu-item" v-for="item in menuList" :key="item.key" :class="`menu-${item.key}`"
          @click="handleClick(item)">
          <div class="menu-icon">
            <img v-if="item.iconSrc" :src="item.iconSrc" alt="" class="icon-img" />
          </div>

          <div class="tip-label">{{ item.label }}</div>

          <div class="badge" v-if="item.badge">
            {{ item.badge > 999 ? '999+' : item.badge > 99 ? '99+' : item.badge }}
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "FloatQuickEntry",

  data() {
    return {
      pos: {
        left: window.innerWidth - 72,
        top: window.innerHeight - 300
      },

      // 记录按钮距离浏览器右边、底部的距离
      rightOffset: 16,
      bottomOffset: 100,

      isDragging: false,
      offsetX: 0,
      offsetY: 0,

      user: localStorage.getItem("user")
    };
  },

  computed: {
    menuList() {
      const unread = this.$store.state.chatUnreadCount || 0;

      return [
        {
          key: "chat",
          label: "聊天窗口",
          color: "#2d6fc4",
          badge: unread > 0 ? unread : "",
          iconSrc:
            "https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/chat.png"
        },
        {
          key: "filemanage",
          label: "文件管理",
          color: "#52c41a",
          badge: "",
          iconSrc:
            "https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/filep.png"
        }
      ];
    }
  },

  mounted() {
    document.addEventListener("mousemove", this.onMouseMove);
    document.addEventListener("mouseup", this.onMouseUp);
    this.updateOffsets();
    window.addEventListener("resize", this.handleWindowResize); // 监听浏览器窗口大小变化
  },

  beforeDestroy() {
    document.removeEventListener("mousemove", this.onMouseMove);
    document.removeEventListener("mouseup", this.onMouseUp);
    window.removeEventListener("resize", this.handleWindowResize);
  },

  methods: {
    handleMouseDown(e) {
      if (e.button !== 0) return;
      this.isDragging = true;
      this.offsetX = e.clientX - this.pos.left;
      this.offsetY = e.clientY - this.pos.top;
    },
    onMouseMove(e) {
      if (!this.isDragging) return;
      let x = e.clientX - this.offsetX;
      let y = e.clientY - this.offsetY;
      x = Math.max(10, Math.min(window.innerWidth - 72, x));
      y = Math.max(10, Math.min(window.innerHeight - 100, y));
      this.pos.left = x;
      this.pos.top = y;
      this.updateOffsets();
    },

    onMouseUp() {
      this.isDragging = false;
    },
    updateOffsets() {
      const sidebarWidth = 80;
      const sidebarHeight = this.getSidebarHeight();

      this.rightOffset =
        window.innerWidth - this.pos.left - sidebarWidth;

      this.bottomOffset =
        window.innerHeight - this.pos.top - sidebarHeight;
      this.rightOffset = Math.max(10, this.rightOffset);
      this.bottomOffset = Math.max(10, this.bottomOffset);
    },
    //  浏览器窗口大小改变
    handleWindowResize() {
      this.$nextTick(() => {
        this.restorePosition();
      });
    },
    restorePosition() {
      const sidebarWidth = 80;
      const sidebarHeight = this.getSidebarHeight();
      // 根据之前保存的右边距离重新计算 left
      let left =
        window.innerWidth -
        sidebarWidth -
        this.rightOffset;
      // 根据之前保存的底部距离重新计算 top
      let top =
        window.innerHeight -
        sidebarHeight -
        this.bottomOffset;
      // 防止超出左边
      left = Math.max(10, left);
      // 防止超出顶部
      top = Math.max(10, top);
      // 防止超出右边
      const maxLeft =
        window.innerWidth -
        sidebarWidth -
        10;
      // 防止超出底部
      const maxTop =
        window.innerHeight -
        sidebarHeight -
        10;
      left = Math.min(left, Math.max(10, maxLeft));
      top = Math.min(top, Math.max(10, maxTop));
      this.pos.left = left;
      this.pos.top = top;
    },
    getSidebarHeight() {
      const itemHeight = 36;
      const gap = 10;
      const padding = 28;
      const count = this.menuList.length;
      return (
        padding +
        count * itemHeight +
        Math.max(0, count - 1) * gap
      );
    },
    handleClick(item) {
      this.$emit("menu-click", item);

      if (item.key == "chat") {
        this.$store.dispatch("openkey", {
          key: "chat",
          by: true
        });

        this.$store.dispatch("openkey", {
          key: "filemanage",
          by: false
        });

        this.$nextTick(() => {
          this.$emit("expand-first-group");
        });
      } else {
        this.$store.dispatch("openkey", {
          key: "filemanage",
          by: true
        });

        this.$store.dispatch("openkey", {
          key: "chat",
          by: false
        });
      }
    }
  }
};
</script>

<style scoped>
.float-quick-wrap {
  position: fixed;
  z-index: 990;
  user-select: none;
}

.float-sidebar {
  width: 56px;
  padding: 14px 12px;
  border-radius: 22px;
  background: rgba(255, 255, 255, 0.58);
  backdrop-filter: blur(26px);
  -webkit-backdrop-filter: blur(26px);
  border: 1px solid rgba(255, 255, 255, 0.72);
  color: #fff;
  box-shadow:
    0 18px 45px rgba(0, 0, 0, 0.12),
    0 0 0 1px rgba(255, 255, 255, 0.9) inset;
}

.sidebar-header {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 14px;
}

.dots {
  display: flex;
  gap: 5px;
}

.dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

.dot.red {
  background: #ff5f57;
}

.dot.yellow {
  background: #ffbd2e;
}

.dot.green {
  background: #28c840;
}

.avatar {
  width: 32px;
  height: 32px;
  margin: 0 auto 14px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea, #764ba2);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.18);
}

.divider {
  height: 1px;
  background: linear-gradient(90deg,
      transparent,
      rgba(0, 0, 0, 0.08),
      transparent);
  margin: 12px 0;
}

.menu-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.menu-item {
  position: relative;
  width: 36px;
  height: 36px;
  border-radius: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.25s ease;
  color: #5f6368;
}

.menu-item:hover {
  transform: translateY(-1px);
}

.menu-icon {
  width: 26px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-img {
  width: 26px;
  height: 26px;
}

.menu-icon svg {
  width: 26px;
  height: 26px;
  transition: 0.25s ease;
}

/* 悬浮提示文字 */
.tip-label {
  position: absolute;
  right: 48px;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.92);
  color: #1890ff;
  font-size: 12px;
  padding: 5px 10px;
  border-radius: 8px;
  white-space: nowrap;
  box-shadow: 0 4px 14px rgba(132, 209, 233, 0.22);
  opacity: 0;
  pointer-events: none;
  transition: all 0.22s ease;
  font-weight: 500;
}

.menu-item:hover .tip-label {
  opacity: 1;
  transform: translateY(-50%) translateX(4px);
}

/* 消息角标 */
.badge {
  position: absolute;
  top: -5px;
  right: -4px;
  background: linear-gradient(135deg, #fc3c1a, #f80d0d);
  color: #fff;
  font-size: 10px;
  padding: 1px 6px;
  border-radius: 10px;
  font-weight: 600;
  z-index: 2;
  text-align: center;
}

/* 彩色图标 + 对应光晕 */
.menu-filemanage:hover,
.menu-filemanage .tip-label {
  color: #2d6fc4;
}

.menu-filemanage:hover svg {
  filter: drop-shadow(0 0 8px rgba(22, 204, 250, 0.65));
}

.menu-chat:hover,
.menu-chat .tip-label {
  color: #2d6fc4;
}

.menu-chat:hover svg {
  filter: drop-shadow(0 0 8px rgba(22, 204, 250, 0.65));
}
</style>